import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "AlignCenter.svg",
  "use": "AlignCenter.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"AlignCenter.svg\"><path d=\"M44.0208,46.0207a2,2,0,0,1,0,4h-24a2,2,0,0,1,0-4Zm6-4h-36a2,2,0,0,1,0-4h36a2,2,0,0,1,0,4Zm-32-16a2,2,0,0,1,0-4h28a2,2,0,1,1,0,4Zm33,6a2,2,0,0,1-2,2h-34a2,2,0,0,1,0-4h34A2,2,0,0,1,51.0208,32.0208Zm-1-14h-36a2,2,0,1,1,0-4h36a2,2,0,1,1,0,4Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol